import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { insuranceTypesDataSource } from 'infrastructure/data-sources/insurance-types';

import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';
import type { IInsuranceTypeItem } from 'infrastructure/data-sources/insurance-types';

type Options = IBaseSelectBoxOption<
  IInsuranceTypeItem['id'],
  IInsuranceTypeItem
>[];

interface IInsuranceTypeSelectBoxProps
  extends Omit<IBaseSelectBoxProps, 'options'> {}

const InsuranceTypeSelectBox: React.FC<IInsuranceTypeSelectBoxProps> = (
  props,
) => {
  const dataSource = useMemo(() => insuranceTypesDataSource(), []);

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return <BaseSelectBox options={options} {...props} />;
};

export default InsuranceTypeSelectBox;
